var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblemaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 444 263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(0 -141.487 141.487 0 5074.5 13987)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f17ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b038fa"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(0 -332.592 332.592 0 4856.64 13927.6)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c41baf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f52586"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(0 -332.592 332.592 0 4856.64 13927.6)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3054b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a4fc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5074.5 13845.5s62.5 34.4 62.5 79c0 34.5-28.01 62.5-62.5 62.5s-62.5-28-62.5-62.5c0-44.6 62.5-79 62.5-79z",
    fill: "url(#a)",
    transform: "matrix(-.60382 -.60382 .60382 -.60382 -5290.88 11680.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4796.35 13671.2c0-43 60.29-76.2 60.29-76.2s60.3 33.2 60.3 76.2v196.1c0 33.3-27.02 60.3-60.3 60.3s-60.29-27-60.29-60.3z",
    fill: "url(#b)",
    transform: "matrix(.76656 -.44258 .44258 .76656 -9638.51 -8272)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4796.35 13671.2c0-43 60.29-76.2 60.29-76.2s60.3 33.2 60.3 76.2v196.1c0 33.3-27.02 60.3-60.3 60.3s-60.29-27-60.29-60.3z",
    fill: "url(#c)",
    transform: "matrix(.76656 -.44258 .44258 .76656 -9469.69 -8272)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblemaps);
export default __webpack_public_path__ + "static/media/bubblemaps.4ee354a8f7ab1b93f827cd7e3dc5546e.svg";
export { ForwardRef as ReactComponent };